import {Flag} from 'platform/components';

import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

interface PhotoGuideMissingRequiredFlagProps extends TestIdProps {
  count: number;
}

/** The advisory counter of required slots without a photo; it never blocks anything. */
export function PhotoGuideMissingRequiredFlag(props: PhotoGuideMissingRequiredFlagProps) {
  return (
    <Flag
      label={i18n.t('entity.photoGuide.labels.missingRequiredPhotos', {count: props.count})}
      colorScheme="orange"
      isSubtle
      size="small"
      data-testid={props['data-testid']}
    />
  );
}
